import React, { useMemo } from "react";

import "./index.less";
import parseYuqueMarkdown from "./parser";

/**
 * 语雀导出的 Markdown 渲染器（可插拔）
 *
 *   <YuqueMarkdown markdown={mdString} />
 *
 * - 输入：Markdown 字符串（语雀导出口径，见 HANDLING.md）
 * - 输出：带内置样式的 React 组件，直接放进任意容器即可；宽度填满父容器
 * - 正文列宽由页面容器决定（设计稿：1920→1394 / 1366→960 / 1024→618），
 *   组件本身不铺页面底色、不控制栏宽，方便插到文章页 / 弹窗 / 资料卡片里
 * - 空字符串返回 null
 */
export default function YuqueMarkdown({ markdown, className, ...rest }) {
  const source = typeof markdown === "string" ? markdown : "";
  const nodes = useMemo(
    () => (source.trim() ? parseYuqueMarkdown(source) : null),
    [source]
  );

  if (!nodes) return null;

  return (
    <div
      className={["yuque-md", className].filter(Boolean).join(" ")}
      {...rest}
    >
      {nodes}
    </div>
  );
}

export { parseYuqueMarkdown };
